module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/ai703-0ea514c6cc0010e5bf988156dc215036.jpg";